import axios from "axios";
import { API_URL } from "@/constants/environment";
import axiosInstance from "./axios.instance";

const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

class VendorService {

  async updateVendorProfile(vendorId, profileData) {
    try {
      // Make sure you're passing the correct formData to the backend
      const response = await axiosInstance.put(`/vendors/${vendorId}`, profileData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Axios will automatically set this, but you can set it explicitly
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
async fetchVendors(page, limit, locationParam = '') {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/vendors/approved?page=${page}&limit=${limit}${locationParam}`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      }
    );
    return response?.data?.data.vendors || [];
  } catch (err) {
    console.error("Error getting vendors:", err);
    return [];
  }
}


  async submitReview({ customer, vendor, rating, comment }) {
    try {
      const response = await axiosInstance.post("/reviews", {
        customer,
        vendor,
        rating,
        comment,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async fetchReviews(vendorId) {
    if (!vendorId) {
      console.error("fetchReviews: Missing vendorId!");
      return [];
    }
    try {
      const response = await axiosInstance.get(`/reviews/${vendorId}`);
      return response.data.data?.data || [];
    } catch (error) {
      return [];
    }
  }

  async scheduleTimeSlot(customerId, vendorId, dateTime) {
    try {
      const payload = {
        customerId,
        vendorId,
        dateTime,
      };

      const response = await axiosInstance.post(
        "/customers/time-slot/schedule",
        payload
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getCityFromPostcode(postcode) {
    try {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${postcode}&key=${GOOGLE_API_KEY}`;
      const response = await axios.get(url);

      if (response.data.results.length > 0) {
        const addressComponents = response.data.results[0].address_components;
        const cityComponent = addressComponents.find((component) =>
          component.types.includes("locality")
        );
        return cityComponent ? cityComponent.long_name : "City not found";
      }
      throw new Error("Invalid postcode or no results found.");
    } catch (err) {
      console.error("Error fetching city:", err);
      throw new Error("Failed to fetch city.");
    }
  }

  async fetchServicesByType(serviceType) {
    try {
      const response = await axiosInstance.get(
        `/vendors/service/by-type?servicesType=${encodeURIComponent(serviceType)}`
      );
      return response.data?.data || [];
    } catch (err) {
      console.error("Error fetching services by type:", err);
      throw new Error("Failed to fetch services by type.");
    }
  }

  async fetchVendorsByLocation(postcode = '', city = '', latitude = '', longitude = '', filters = {}, page=1, limit=10) {
    try {
      const params = {};
  
      if (postcode) params.post_code = postcode;
      if (city) params.city = city;
      if (latitude) params.latitude = latitude;
      if (longitude) params.longitude = longitude;
  
      // Add filters with correct formatting
      if (filters.vendorType) params.vendor_type = filters.vendorType.join(',');
      if (filters.serviceType && Array.isArray(filters.serviceType)) {
        params.service_type = filters.serviceType.join(',');
      }
      if (filters.rating) params.min_rating = parseInt(filters.rating);
  
      params.page = page;
      params.limit = limit;
      const response = await axiosInstance.get("/vendors/search", { params });
      return response.data.data || [];
    } catch (err) {
      console.error("Error fetching vendors:", err);
      throw new Error("Failed to fetch vendors.");
    }
  }
  
  async fetchVendorById(vendorId = "null") {
    try {
      const response = await axiosInstance.get(`/vendors/${vendorId}`);
      return response.data.data.data || {};
    } catch (err) {
      console.error("Error fetching vendor:", err);
      throw new Error("Failed to fetch vendor.");
    }
  }

  async claimVendorById(vendorId) {
    try {
      const response = await axiosInstance.post(`/vendors/claim?vendorId=${vendorId}`);
      return response.data || {};
    } catch (err) {
      console.error("Error claim vendor:", err);
      throw new Error("Failed to claim vendor.");
    }
  }

  async getVendorAttachments(vendorId) {
    try {
      const response = await axiosInstance.get(`/vendors/attachments/${vendorId}`);
      return response.data.data || { licenses: [], certificates: [] };
    } catch (err) {
      console.error("Error fetching vendor attachments:", err);
      throw new Error("Failed to fetch vendor attachments.");
    }
  }
}

export default new VendorService();
